import { useCallback, useEffect, useState } from 'react';
import useImageSliderState from 'modules/dashboard/hooks/use-image-slider-state';
import { useQuery } from '@tanstack/react-query';
import { getAutodeskIntegrationViewerImages } from 'api/services';

const useAutodeskCameraImages = (token: string) => {
    const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true);

    const { images, selectedImage, setSelectedImage, selectedDate, setSelectedDate, endDate, startDate, setState } =
        useImageSliderState();

    const imagesQuery = useQuery(['autodeskCamerasImages', token, selectedDate], () =>
        getAutodeskIntegrationViewerImages(token, selectedDate)
    );

    useEffect(() => {
        if (imagesQuery.isFetching) return;

        const data = imagesQuery.data;

        const images = data.images;

        const index = 0;

        setState({ images: images, startDate: data.startDate, endDate: data.endDate, index: index });

        if (isInitialLoading) {
            setIsInitialLoading(false);
        }
    }, [imagesQuery.isFetching, imagesQuery.data, setState, isInitialLoading]);

    const refetch = useCallback(() => {
        imagesQuery.refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        isInitialLoading,
        isLoading: imagesQuery.isLoading,
        images,
        selectedImage,
        setSelectedImage,
        selectedDate,
        setSelectedDate,
        startDate,
        endDate,
        refetch,
    };
};

export default useAutodeskCameraImages;
